import React from 'react'

import './styles.css'
import ContactForm from './components/ContactForm'
import Disclaimer from './components/Disclaimer'
import { EResult } from './components/ContactForm/components/Result'

function Sidebar({ className = '', onToggle = () => {}, onTransitionEnd = () => {}, onFormResult }) {
  return (
    <div
      onTransitionEnd={onTransitionEnd}
      id="sidebar"
      className={`w-[var(--sidebar-width)] max-h-[screen] overflow-y-auto relative z-[400] shadow-xl flex-shrink-0 bg-white pb-[16px] px-[24px] border-l-[1px] border-solid border-[#C7CCD9] ${className}`}
    >
      <ContactForm
        onResult={onFormResult}
        onClose={(result) => {
          if (result === EResult.SUCCESS) {
            onToggle(false)
          }
        }}
      />
    </div>
  )
}

export default Sidebar
